import { RectAreaLight } from "three"

export const Light = ({position, rotation, intensity, castShadow, penumbra, distance}) => {
    return(
        <mesh position={position} rotation={rotation}>
            {/* <sphereBufferGeometry args={[0.1]}/> */}
            <meshBasicMaterial color={'white'}/>
            <spotLight 
                position={position}  
                intensity={intensity}
                angle={(Math.PI/2 * 0.3)}
                penumbra={penumbra} 
                castShadow={castShadow}
                shadow-mapSize-width={2**10}
                shadow-mapSize-height={2**10}
                distance={distance}
                decay={2}
            />
        </mesh>
    )
}